<template>
  <div>
    <div class="guanyuwomen">

    </div>
    <!-- 项目 -->
    <div class="projects">
      <div>机构项目</div>
      <div class="projects-item">
        <div
          class="item-box"
          v-for="(item, index) in projectsList"
          :key="index"
          @mouseover.stop="getIn(index, $event)"
          @mouseout="getLeave()"
          @click="goDetail(item , index)"
        >
          <div><img :src="item.url" alt="" /></div>
          <div
            class="projects-item-foot"
            :class="{ activeBox: getCurrent == index }"
          >
            <div>{{item.title}}</div>
            <div>{{item.introduce}}</div>
            <div v-show="getCurrent == index" @click.stop="projectGo(item.linkTo)" >
              <img src="../assets/gengduobtn.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 动态 -->
    <div class="dynamic">
      <div class="dynamic-content">
        <div class="dynamic-content-left" @click="goDynamicsDetail(0,0)">
          <div>机构动态</div>
          <div  @mouseover="dynamicShow=true" @mouseout="dynamicShow=false" :style="{color:dynamicShow?'#c1141e':''}">{{dynamicList[0].title}}</div>
          <div  @mouseover="dynamicShow=true" @mouseout="dynamicShow=false">
            {{dynamicList[0].introduce}}
          </div>
          <div @click.stop="projectGoTo(1)">
            <span style="font-weight: 700">查看更多</span>
            <img src="../assets/woyaojuankuangyou.svg" alt="" />
          </div>
        </div>
        <div class="dynamic-content-right">
          <div class="mark">
            <div class="mark-wrap">
              <div
                class="mark-item"
                v-for="(v, i) in dynamicList2"
                :key="i"
                @click="dynamicCur = i"
                :class="dynamicCur == i ? 'dynamicAcitve' : ''"
                @mouseover="dynamicCur = i"
                @mouseout="dynamicCur = -1"
                
              >
              <div @click="goDynamicsDetail(i,0)">
                <div><img :src="FILE_BASE_URL+v.image" /></div>
                <div class="con">
                  <div class="tit" :style="{color:dynamicCur == i?'#c1141e':''}">{{v.title}}</div>
                  <div class="introduce">{{v.introduce}}</div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 公益活动 -->
    <div class="benefit">
      <div class="benefit-content">
        <div>公益活动</div>
        <div class="benefit-content-banner">
          <!-- 左 -->
          <div class="left-swiper" v-for="(v, i) in benefitList" :key="i">
            <img
             :src="FILE_BASE_URL+v.image"
              alt=""
              :style="{ opacity: current == i ? '1' : '0' }"
              @click="goDynamicsDetail(i,4)" 
            />
          </div>
          <div class="left-none"></div>
          <!-- 右 -->
          <div class="swiper">
            <div>
              <div>公益行动，传递爱</div>
            </div>
            <div class="swiper-list" ref="swiperList">
              <div
                class="swiper-list-item"
                v-for="(v, i) in benefitList"
                :key="i"
                ref="swiperScroll"
                @click="swiperListItemClick(i)"
                @mouseover="swiperOver(i)"
                @mouseout="swiperOut"
              >
                <div :class="{ border: current == i }">
                  <img :src="FILE_BASE_URL+v.image" />
                </div>
                <div>
                  <div :class="{ fontColor: current == i }">
                    {{v.title}}
                  </div>
                  <div>{{v.releaseDate}}</div>
                </div>
              </div>
            </div>
            <div class="diceng" ><img src="../assets/diceng.png" alt="" /></div>
          </div>
        </div>
        
      </div>
      <div class="look-more" @click="projectGoTo(2)">
          <div class="look-more-box">
            <span style="font-weight: 700">查看更多</span>
            <img src="../assets/woyaojuankuangyou.svg" alt="" />
          </div>
      </div>
    </div>
    <!-- 志愿者风采 -->
    <div class="volunteer">
      <div class="volunteer-content">
        <div>志愿者风采</div>
        <div class="carousel">
          <Swiper />
        </div>
        <div class="look-more" @click="projectGoTo(3)" style="background:#fff">
          <div class="look-more-box">
            <span style="font-weight: 700">查看更多</span>
            <img src="../assets/woyaojuankuangyou.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 志愿者服务站 -->
    <div class="station">
      <div class="station-content">
        <div class="station-content-head">
          <div></div>
          <div>志愿者服务站</div>
          <div>
            <span
              v-for="i in 3"
              :key="i"
              :style="{ background: i == showNum ? '#C1141E' : '#E6E6E6' }"
            ></span>
          </div>
        </div>
        <div class="station-content-main">
          <div class="list">
            <div 
              v-for="(item, index) in imgList"
              :key="index"
              class="station-item"
              :class="{'hover':hoverIndex===index }"
              @mouseenter="mouseInter(index)"
              @click="goStationDetail(item)"
            >
              <div class="img-box">
                <img :src="FILE_BASE_URL+item.image"/>
              </div>
              <div class="station-item-con">
                <div class="tit">{{item.name}}</div>
                <div class="intro">{{item.introdution}}</div>
              </div>
              <div class="btn">查看详情</div>
            </div>
          </div>

          <div class="station-look-more" @click="projectGoTo(4)">
            <div class="station-look-more-box">
              <span style="font-weight: 700">查看更多</span>
              <img src="../assets/woyaojuankuangyou.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 捐款 -->
    <div class="contribution">
      <div class="contr-font">
        <img src="../assets/testimg/juankuanimg/zhenxinfont.svg" alt="">
      </div>
      <div
        @click="$router.push('/contribution?index=6&title=我要捐款&curIndex=0')"
        @mouseover="isShowYou = true"
        @mouseout="isShowYou = false"
      >
        我要捐款
        <img
          src="@/assets/woyaojuankuangyou.svg"
          style="margin-bottom: 1px"
          alt=""
          v-if="isShowYou"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {home} from '../api/index'
import Swiper from "../components/swiper";
export default {
  components: {
    Swiper,
  },
  data() {
    return {
      getCurrent: -1,
      isShow: false,
      current: 0,
      benefitList: [],
      projectsList: [
        { url: '' ,title:'安全课堂', linkTo:'/projects?index=2&title=机构项目&curIndex=0'},
        { url: '', title:'希望助学', linkTo:'/projects/hopeStudy?index=2&curIndex=1'},
        { url: '' ,title:'希望行动',linkTo:'/projects/hopeAction?index=2&curIndex=2'},
      ],
      dynamicList: [],
      dynamicList2:[],
      showOpen: true,
      showNum: 1,
      stationList: [],
      navIndex: "",
      dynamicCur: -1,
      isShowYou: false,
      timer: null,
      timer2: null,
      dynamicShow:false,
      hoverIndex:1,
      imgList:[],
      FILE_BASE_URL:this.$API.FILE_BASE_URL
    };
  },
  mounted() {
    this.navIndex = this.$route.query.i;
    localStorage.setItem("currentIndex", this.navIndex);
    this.benefitAuto();

    this.load(0)
    this.load(1)
    this.load(2)

    this.loadDynamics()

    this.loadActivity()

    this.loadStation()
    this.changeNum();
  },
  destroyed(){
    clearInterval(this.timer2);
  },
  methods: {
    changeNum(){
      this.timer2 = setInterval(() => {
        if(this.showNum > 2 ){
          this.showNum = 0;
          this.imgList = this.stationList.slice(0,3)
        }else{
          this.imgList = this.stationList.slice(this.showNum*3,this.showNum*3+3)
        }
        this.showNum++;
      }, 3000);
    },
    /** 机构项目 */
    async load(type){
      let that = this
      const params = {
        type: type,
        pageNo:1,
        pageSize:1
      }
      const res = await this.$API.getFundAgencyManagementlist(params);
      if(res.code === 200){
         that.projectsList[type].url = this.FILE_BASE_URL + res.result.records[0].image
         that.projectsList[type].name = res.result.records[0].name
         that.projectsList[type].contents = res.result.records[0].contents
         that.projectsList[type].id = res.result.records[0].id
         that.projectsList[type].introduce = res.result.records[0].introduce
      }else{
        this.$message.error(res.message);
      }
      console.log('that.projectsList' , that.projectsList)
    },
    /** 机构动态 */
    loadDynamics(){
      let params = {
        'type': 0,
        pageNo:1,
        pageSize:3
      }
      this.$API.getFundNewlist(params).then(res=>{
        let list =  res.result.records;
        this.dynamicList = res.result.records;
        this.dynamicList2 = list.filter((k,i)=>i>0);
      })
    },
    /** 公益活动 */
    loadActivity(){
      let params = {
        'type': 4,
        pageNo:1,
        pageSize:8
      }
      this.$API.getFundNewlist(params).then(res=>{
        this.benefitList = res.result.records
      })
    },
    /** 志愿者服务站 */
    loadStation(){
      let params = {
        type: 1,
        pageNo:1,
        pageSize:9
      }
      this.$API.queryVolunteerPageList(params).then(res=>{
        this.stationList = res.result.records
      })
    },
    goDetail(item , index){
        // 详情数据存本地存储，详情页直接本地存储获取
      localStorage.setItem('info',JSON.stringify(item));

      this.$router.push({
        path:'/projects/detail?index=2&title=机构项目&curIndex=' +index+ '&type=5'
      })
    },
    goDynamicsDetail(i,index){
        // 详情数据存本地存储，详情页直接本地存储获取
        if(index == 0){
          localStorage.setItem('navList',JSON.stringify(this.dynamicList));
        }
        if(index == 4){
          localStorage.setItem('navList',JSON.stringify(this.benefitList));
        }
        
        this.$router.push({
         path:'/newCenter/newcenter/detail?index=4&title=新闻中心&curIndex='+index+'&type=5&infoIndex=' + i
      })
    },
    goStationDetail(item){
        // 详情数据存本地存储，详情页直接本地存储获取
        localStorage.setItem('statileInfo',JSON.stringify(item));

        this.$router.push({
         path:'/volunteer/station/detail?index=5&title=志愿之家&curIndex=1&type=5'
        })
      },
    projectGo(url){
        this.$router.push(url)
    },
    projectGoTo(type){
      let url = ''
      if(type == 1){
        url = '/newcenter?index=4&title=新闻中心&curIndex=0'
      }
      if(type == 2){
        url = '/newCenter/activities?index=4&title=新闻中心&curIndex=4'
      }
      if(type == 3){
        url = '/volunteer?index=5&title=志愿之家&curIndex=0'
      }
      if(type == 4){
        url = '/volunteer/station?index=5&title=志愿之家&curIndex=1'
      }
      this.$router.push(url)
    },
    getIn(index) {
      this.getCurrent = index;
    },
    getLeave() {
      this.getCurrent = -1;
    },
    next() {
      this.current++;
      console.log(this.$refs.swiperScroll);
      if (this.current >= 4) {
        this.$refs.swiperList.scrollTop += 85;
      }
    },
    prev() {
      if (this.current <= 0) {
        this.current--;
        this.current = 0;
      } else {
        this.current--;
        this.$refs.swiperList.scrollTop -= 85;
      }
    },
    swiperListItemClick(i) {
      this.current = i;
    },
    mouseInter(index) {
      this.hoverIndex = index;
    },
    rectClick(i) {
      this.showNum = i;
    },
    getInImage() {
      console.log(1);
    },
    benefitAuto() {
      this.timer = setInterval(() => {
        this.current++;
      }, 3000);
    },
    swiperOver(i) {
      clearInterval(this.timer);
      this.current = i;
    },
    swiperOut() {
      this.benefitAuto();
    },
  },
  watch: {
    current(val) {
      if (val == this.benefitList.length) {
        this.current = 0;
      }
      if (val == 4) {
        this.$refs.swiperList.scrollTop += 85;
      }
      if (val == 0) {
        this.$refs.swiperList.scrollTop -= 85;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.border {
  border: 1px solid #c1141e;
}
.fontColor {
  color: #c1141e;
}
.banner {
  img {
    width: 100%;
    height: 500px;
  }
}
//机构
.projects {
  width: 1200px;
  margin: 0 auto;
  padding: 60px 0;
  > div:nth-child(1) {
    font-size: 26px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    text-align: center;
    color: #333333;
  }
  .projects-item {
    margin-top: 40px;
    display: flex;
    > div:nth-child(2),
    > div:nth-child(3) {
      margin-left: 24px;
    }
    .item-box {
      > div:nth-child(1) {
        img {
          width: 384px;
          height: 256px;
        }
      }
      .projects-item-foot {
        padding-top: 31px;
        position: relative;
        height: 110px;
        > div:nth-child(1) {
          font-size: 18px;
          font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
          font-weight: 700;
          color: #333333;
        }
        > div:nth-child(2) {
          font-size: 14px;
          font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
          font-weight: 400;
          color: #333333;
          margin-top: 14px;
        }
        > div:nth-child(3) {
          position: absolute;
          left: 64%;
          top: -22%;

          img {
            width: 120px;
            height: 40px;
          }
        }
      }
    }
  }
}

.activeBox {
  width: 384px;
  height: 103px;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  padding-left: 20px;
  padding-bottom: 14px;
}
//动态
.dynamic {
  width: 100%;
  height: 518px;
  background: #f6f6f6;
  .dynamic-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .dynamic-content-left {
      padding: 90px 0;
      > div:nth-child(1) {
        font-size: 26px;
        font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
        font-weight: 700;
        color: #333333;
      }
      > div:nth-child(2) {
        font-size: 16px;
        font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
        font-weight: 700;
        color: #333333;
        margin-top: 70px;
      }
      > div:nth-child(3) {
        width: 346px;
        margin-top: 6px;
        font-size: 14px;
        font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
        font-weight: 400;
        color: #777777;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      > div:nth-child(4) {
        margin-top: 100px;
        border-bottom: 3px solid #c1141e;
        width: 90px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 5px;
        span {
          font-size: 14px;
          font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
          font-weight: 700;
          color: #333333;
        }
        img {
          width: 15px;
          height: 9px;
        }
      }
    }
    .dynamic-content-right {
      width: 100%;
      height: 100%;
      margin-left: 8%;
      padding-top: 91px;
      padding-bottom: 60px;

      .mark {
        width: 762px;
        height: 367px;
        background: #efefef;
      }

      .mark-wrap{
        width: 700px;
        height: 367px;
        position: relative;
        top: -30px;
        left: 30px;
        display: flex;
        justify-content: space-between;

        .mark-item {
          width: 336px;
          height: 370px;
          background: #fff;

          img {
            width: 336px;
            height: 189px;
          }

          .con {
            padding:20px;

            .tit {
              font-size: 16px;
              font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
              font-weight:bold;
              color: #333333;
              margin-bottom:10px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .introduce {
                font-size: 14px;
                font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
                font-weight: 400;
                color: #777777;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
          }
        }
      }
     

          // > div:nth-child(2) {
          //   width: 336px;
          //   background: #ffffff;
          //   padding: 25px 20px;

          //   > div:nth-child(1) {
          //     font-size: 16px;
          //     font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
          //     font-weight: 700;
          //     color: #333333;
          //     //   overflow: hidden;
          //     //   text-overflow: ellipsis;
          //     //   display: -webkit-box;
          //     //   -webkit-line-clamp: 2;
          //     //   -webkit-box-orient: vertical;
          //   }
          //   > div:nth-child(2) {
          //     font-size: 14px;
          //     font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
          //     font-weight: 400;
          //     color: #777777;
          //     overflow: hidden;
          //     text-overflow: ellipsis;
          //     display: -webkit-box;
          //     -webkit-line-clamp: 3;
          //     -webkit-box-orient: vertical;
          //   }
          // }
    }
  }
}

//公益活动
.benefit {
  width: 100%;
  background: #ffffff;
  .benefit-content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    
    > div:nth-child(1) {
      font-size: 26px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      text-align: center;
      color: #333333;
    }
    .benefit-content-banner {
      margin-top: 40px;
      display: flex;
      position: relative;
      .touming {
        opacity: 0.3;
      }
      .left-swiper {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 1;
        transition: 1s;
        img {
          width: 712px;
          height: 400px;
          transition: 2s;
        }
      }
      .left-none {
        width: 712px;
        height: 400px;
      }
      .swiper {
        width: 486px;
        height: 408px;
        box-sizing: border-box;
        background: #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.04);
        position: relative;
        .img1 {
          width: 16px;
          height: 16px;
        }
        > div:nth-child(1) {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          padding: 20px;
          font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
          font-weight: 700;
          color: #262626;
          > div:nth-child(2) {
            display: flex;
            > div:nth-child(1) {
              margin-right: 24px;
            }
          }
        }
        .swiper-list {
          width: 100%;
          height: 340px;
          padding: 0 20px;
          overflow: hidden;
          &:hover {
            overflow-y: overlay;
          }
          > div:not(:first-child) {
            margin-top: 20px;
          }
          .swiper-list-item {
            display: flex;
            > div:nth-child(1) {
              img {
                width: 116px;
                height: 62px;
              }
            }
            > div:nth-child(2) {
              margin-left: 12px;
              > div:nth-child(1) {
                font-size: 13px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              > div:nth-child(2) {
                margin-top: 8px;
                font-size: 12px;
                color: #999999;
              }
            }
          }
        }
        .diceng {
          position: absolute;
          left: 0;
          bottom: -7px;
          img {
            vertical-align: super;
          }
        }
      }
    }
  }
}

//志愿者
.volunteer {
  width: 100%;
  .volunteer-content {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0 0 0;
    > div:nth-child(1) {
      font-size: 26px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      text-align: center;
      color: #333333;
    }
  }
  .carousel {
    margin-top: 48px;
  }
}

//志愿者服务站
.station {
  width: 100%;
  height: 647px;
  background: url("../assets/desebg.png") center no-repeat;
  background-size: 100% 100%;

  .station-content {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0;

    .station-content-head {
      display: flex;
      justify-content: space-between;

      > div:nth-child(2) {
        margin-left: 140px;
        font-size: 26px;
        font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
        font-weight: 700;
        text-align: center;
        color: #333333;
      }
      > div:nth-child(3) {
        display: flex;
        align-items: flex-end;
        > span:not(:last-child) {
          margin-right: 20px;
        }
        span {
          display: inline-block;
          width: 26px;
          height: 4px;
          background: #e6e6e6;
        }
      }
    }

    .station-content-main {
      padding-top: 40px;
      .list {
        display: flex;
        justify-content: space-between;
        width: 1200px;
      }

      .station-item {
        flex: 0 0 auto;
        width: 292px;
        height: 370px;
        transition:all 300ms;
        cursor: pointer;
        border-left: 3px solid #c1141e;
        background: #fff;
        position: relative;
        margin-right: 33px;

        .img-box {
          width: 100%;
          img {
            width: 100%;
            height: 172px;
          }
        }

        .station-item-con {
          width: 100%;
          position: relative;
          padding:20px 20px 0 20px;

          .tit {
            font-size: 18px;
            font-weight: 700;
            color: #333333;
          }

          .intro {
            color:#777777;
            height:40px;
            line-height:20px;
            font-size: 14px;
            margin:30px 0;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            white-space: normal !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

        .btn {
            height: 50px;
            line-height: 50px;
            font-size: 14px;
            font-weight: 400;
            color: #777777;
            padding: 0 20px;
        }

        &.hover {
          width: 547px;
          background: rgba(255,255,255,.5);

          .img-box {
            img {
              width: 100%;
              height: 320px;
            }
          }

          .station-item-con {
            padding-top: 10px;
            position: absolute;
            bottom: 50px; 
            background: rgba(255,255,255,.8);

            .tit {
              margin-bottom:10px;
            }

            .intro {
              color:#333;
              margin: 20px 0;
            }
          }

          .btn {
            color: #fff;
            background: #c1141e;
          }
        }
      }
    }
  }
}

// 捐款
.contribution {
  widows: 100%;
  height: 140px;
  background: url("../assets/testimg/juankuanimg/juankuan22.png") no-repeat;
  background-size: 1920px 140px;
  background-position: top center;
  text-align: center;
  line-height: 80px;
  position: relative;
  > div:nth-child(2) {
    width: 108px;
    height: 40px;
    background: #ffffff;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    color: #c1141e;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-54px) translateY(14px);
    cursor: pointer;
  }
}
.lookDetail {
  width: 100%;
  height: 50px;
  background: #c1141e;
  line-height: 50px;
  color: #ffffff;
  position: absolute;
  left: 0;
  bottom: 0;
  padding-left: 20px;
}
//查看详情
.look-more {
  height: 128px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, rgba(251, 251, 251, 0) 42%, #f9f9f9 100%);
  .look-more-box {
    display: flex;
    width: 90px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 3px solid #c1141e;
    padding-bottom: 5px;
    img {
      width: 15px;
      height: 9px;
    }
  }
}
.station-look-more {
  height: 128px;
  display: flex;
  justify-content: center;
  align-items: center;

  .station-look-more-box {
    display: flex;
    width: 90px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 3px solid #c1141e;
    padding-bottom: 5px;
    img {
      width: 15px;
      height: 9px;
    }
  }
}
.dynamicAcitve {
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}

.guanyuwomen {
  width: 100%;
  height: 500px;
  background-image: url("../assets/testimg/banner3.png");
  background-size: 1920px 500px;
  background-repeat: no-repeat;
  background-position: top center;
}

.contr-font{
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}

.dynamicTitle{
  &:hover{
    color: red;
  }
}
</style>
